import { dateOf, dayOfWeek, timeOf, type LocalDate, type LocalDateTime } from './time';

export const DOWS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const DOWL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const MONS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const ymd = (d: LocalDate) => d.slice(0, 10).split('-').map(Number) as [number, number, number];

/** "10 AM", "10:30 AM" */
export function fTime(s: LocalDateTime): string {
  const [hh, mm] = timeOf(s).split(':').map(Number) as [number, number];
  const ap = hh >= 12 ? 'PM' : 'AM', h = hh % 12 || 12;
  return mm ? `${h}:${String(mm).padStart(2, '0')} ${ap}` : `${h} ${ap}`;
}

/** "Sat 3 Oct" (opts: dow=false, year=true) */
export function fDate(s: LocalDate | LocalDateTime, o: { dow?: boolean; year?: boolean } = {}): string {
  const [y, m, d] = ymd(s);
  return `${o.dow === false ? '' : DOWS[dayOfWeek(dateOf(s))] + ' '}${d} ${MONS[m - 1]}${o.year ? ' ' + y : ''}`;
}

export function fLong(s: LocalDate | LocalDateTime): string {
  const [y, m, d] = ymd(s);
  return `${DOWL[dayOfWeek(dateOf(s))]}, ${d} ${MONTHS[m - 1]} ${y}`;
}

export const fDT = (s: LocalDateTime) => `${fDate(s)}, ${fTime(s)}`;

export function fRange(a: LocalDateTime, b: LocalDateTime): string {
  return dateOf(a) === dateOf(b) ? `${fDate(a)} · ${fTime(a)} – ${fTime(b)}` : `${fDate(a)}, ${fTime(a)} → ${fDate(b)}, ${fTime(b)}`;
}

/** "16–17 Oct", "30 Oct – 2 Nov" */
export function fShort(a: LocalDateTime, b: LocalDateTime): string {
  const [, ma, da] = ymd(a), [, mb, db] = ymd(b);
  if (dateOf(a) === dateOf(b)) return fDate(a);
  if (ma === mb) return `${da}–${db} ${MONS[ma - 1]}`;
  return `${da} ${MONS[ma - 1]} – ${db} ${MONS[mb - 1]}`;
}

/** "1d 4h", "3h 20m", "12m" */
export function dur(ms: number): string {
  ms = Math.abs(ms);
  const d = Math.floor(ms / 86_400_000), h = Math.floor((ms % 86_400_000) / 3_600_000), m = Math.floor((ms % 3_600_000) / 60_000);
  return d ? `${d}d ${h}h` : h ? `${h}h ${m}m` : `${m}m`;
}

export function greeting(s: LocalDateTime): string {
  const h = Number(timeOf(s).slice(0, 2));
  return h < 12 ? 'Good morning' : h < 17 ? 'Good afternoon' : 'Good evening';
}
